// ABOUTME: Icon component for combined chart mode (overlaid series)
// ABOUTME: Shows multiple overlapping lines on a single chart area

import type { FC } from "react"

interface ChartCombinedIconProps {
  className?: string
  size?: number
  color?: string
}

export const ChartCombinedIcon: FC<ChartCombinedIconProps> = ({ className, size = 16, color = "currentColor" }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Chart area background */}
      <rect
        x="2"
        y="2"
        width="12"
        height="12"
        rx="1"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
      />
      {/* Three overlapping lines representing combined series */}
      <path
        d="M3 10L6 7L9 9L13 5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12L6 9L9 11L13 7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.6"
      />
      <path
        d="M3 8L6 5L9 7L13 3"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.4"
      />
    </svg>
  )
}
